export default {"src":"/_next/static/media/raiseFundIdea.0ab6c1e6.svg","height":716,"width":563};